import styles from './template.css';
import template from './template';
import {AoflElement, customElement} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../i18n';

/**
 * @summary CdivComponent
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('cdiv-component')
class CdivComponent extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of CdivComponent.
   */
  constructor() {
    super();
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static get is() {
    return 'cdiv-component';
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default CdivComponent;
